$(document).ready(function(){
  //Cart Notes Logic
  var typingTimer;                //timer identifier
  var doneTypingInterval = 2000;  //time in ms, 5 second for example
  var $drawerInstruction = $('#CartSpecialInstructionsDrawer');
  var $cartInstruction = $('#CartSpecialInstructions');

  $('#CartSpecialInstructionsDrawer').on('keyup', function(){
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTypingDrawerInstructions, doneTypingInterval);
  });

  $('#CartSpecialInstructionsDrawer', '#CartSpecialInstructions').on('keydown', function(){
    clearTimeout(typingTimer);
  });

  function doneTypingDrawerInstructions(){
    CartJS.setNote($drawerInstruction.val());
  }

  $('#CartSpecialInstructions').on('keyup', function(){
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTypingInstructions, doneTypingInterval);
  });

  function doneTypingInstructions(){
    CartJS.setNote($cartInstruction.val());
  }
  //Cart Show
  $('#CartDrawer a.close').click(function(){
    $('#CartDrawer').removeClass('show');
  });
  
  $('#CartLink, .cart-link').click(function(){
    $('#CartDrawer').addClass('show');
    $('#quickview-wrapper').addClass('active');
  });
})


//Toggle Mobile Nav
$(document).ready(function(){
  //Toggle Mobile Navigation
  $('#hamburger-menu').click(function(){
    $('nav#mobile-nav').fadeIn();
    $('nav#mobile-nav').toggleClass('fixed');
    $('body').toggleClass('fixed');
  });

  $('.mobile-search-trigger').click(function(){
    $('nav#mobile-nav').fadeIn();
    $('body').toggleClass('fixed');
  });

  $('#nav-hamburger-menu').click(function(){
    $('nav#mobile-nav').fadeOut();
    $('nav#mobile-nav').toggleClass('fixed');
    $('body').toggleClass('fixed');
  });

//Handle Mobile Nav Accordion
  var acc = document.getElementsByClassName("mobile-nav-main-link");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].onclick = function() {
      var toggleIcon = $(this).children('.toggle');
      toggleIcon.toggleClass("active");
      if(toggleIcon.hasClass('active')){
        toggleIcon.text('-');
      }else{
        toggleIcon.text('+');
      }
      var panel = this.parentElement.nextElementSibling;
      if (panel.style.maxHeight){
        panel.style.maxHeight = null;
      } else {
        if(panel.classList.contains('details')){
          panel.style.maxHeight = "initial";
        }else{
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      } 
    }
  }
});

//Reset Quickview
$('#quickview-wrapper, .quickview-close').click(function(){
  $('#quickview-wrapper').removeClass('active');
  $('#quickview').removeClass('active');
  $('#quickview .content .image-container').empty();
  $('#quickview .content .product-details').empty();
  $('#quickview .content .social-details').empty();
  $('#quickview .content .thumbnails').empty();
  $('#quickview .pdf-data #QuickViewProductPDFSectionOne').empty();
  $('#quickview .pdf-data #QuickViewProductPDFDescription').empty();
  concrete.init();
});

$('#quickview-wrapper, #CartDrawer .close').click(function(){
  $('#quickview-wrapper').removeClass('active');
  $('#CartDrawer').removeClass('show');
});
//Open Quickview and reinitialize concrete to work with quickview form
$('.quickview-btn').click(function(){
  $('#quickview-wrapper').addClass('active');
  var product_url = $(this).data('product');

  $.ajax({
    type: 'GET',
    url: product_url,
    beforeSend: function() {
    },
    success: function(data) {
      function toTitleCase(str)
      {
          return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      }

      // remove loading feedback
      var mainImage = $(data).find('#ProductMainImageQuickView');
      var thumbnails = $(data).find('#ProductThumbnailImagesQuickView');
      var form = $(data).find('#AddToCartFormQuickView');
      var json = form.data('product-json');

      var pdfSectionOne = $(data).find('#ProductPDFSectionOne');
      var pdfDescription = $(data).find('.description-row');
      var productTitle = '<span class="product-title">'+toTitleCase(json.title)+'</span>';
      var socialLinks = $(data).find('.social-sharing');

      if(pdfDescription.length>0){
        pdfDescription = pdfDescription[0].outerHTML;
      }
      if(pdfSectionOne.length > 0){
        pdfSectionOne = pdfSectionOne[0].outerHTML;
      }

      if(socialLinks.length > 0){
       socialLinks = socialLinks[0].outerHTML;
      }
      if(mainImage.length > 0){
        mainImage = mainImage[0].outerHTML;
      }
      if(thumbnails.length > 0){
        thumbnails = thumbnails[0].outerHTML;
      }
      if(form.length > 0){
        form = form[0].outerHTML;
      }

      $('#quickview .content .image-container').append(mainImage);
      $('#quickview .content .thumbnails').append(thumbnails);
      $('#quickview .content .product-details').append(productTitle);
      $('#quickview .content .product-details').append(form);
      $('#quickview .content .social-details').append('<span>share</span>' + socialLinks);
      $('#quickview .pdf-data #QuickViewProductPDFSectionOne').append(pdfSectionOne);
      $('#quickview .pdf-data #QuickViewProductPDFDescription').append(pdfDescription);
      var selectCallback = function(variant, selector) {
        console.log("Switching variant: ", variant);
        concrete.switchVariantQuickView({
          moneyFormat: "",
          variant: variant,
        })
      };

      jQuery(function($) {
        new Shopify.OptionSelectors('productSelectQuickView', {
          product: json,
          onVariantSelected: selectCallback,
          enableHistoryState: false
        });

        //Add Description to Section 2 of PDF
        $('#quickview #QuickViewProductPDFSectionOne .pdf-description').append($('#quickview #QuickViewProductPDFDescription .description-row p:first').text());
        $('#quickview .pdf-data #QuickViewProductPDFDescription .description-row .table-container table').each(function(){
          $('#QuickViewProductPDFSectionOne .table-container').append($(this).clone());
        });


        //If product Contains StartsAt tag change text of product price
        for(var i = 0; i<json.tags.length; i++){
          if(json.tags[i].indexOf('startsat') > -1){
            var startingValue = json.tags[i].split('_')[1];
            startingValue = 'starting at ' + startingValue;
            $('#ProductPriceQuickView').text(startingValue);
          }
        }

        //Set Label within Dropdowns and use default value
        var productOptions = [];
        for(var i = 0; i<json.options.length; i++){
          var optionObj = {};
          optionObj[i] = json.options[i];
          productOptions.push(optionObj);
        }

        if( typeof(productOptions ) != "undefined" ){
          var defaultOption = '';
          for(i=0;i<productOptions.length;i++) {
            $('.single-option-selector:eq('+ i +')')
            .filter(function() {
              defaultOption = $(this).children('option:first').val();
              return $(this).find('option').length > 1
            })
            .prepend('<option disabled value="'+defaultOption+'">' + productOptions[i][i] + '</option>')
            .val(defaultOption)
          }
        }
      });
      concrete.initQuickView();

      $('#ProductThumbnailImagesQuickView img').click(function(){
        $('#ProductThumbnailImagesQuickView img').removeClass('active');
        $(this).addClass('active');
      });
      
      if(json.variants.length == 1){
        $('.selector-wrapper').hide();
      }

      $('#InquiryButton').click(function(){
        $('#quickview-wrapper, #ProductInquiryModal').addClass('active');
        $('#ProductInquiryModal').css('border','1px solid #CECECE');
      });

      //Set Quickview Inquiry Values for input
      $('#contactFormWrapper .product-title').text(json.title);
      $('#contactFormWrapper input[name="contact[productName]"]').val(json.title);
      var newUrl = $('#contactFormWrapper input[name="contact[productUrl]"]').val() +'/products/'+json.handle;
      $('#contactFormWrapper input[name="contact[productUrl]"]').val(newUrl);

      $('#quickview').addClass('active');
    },
    dataType: "html"
  });
});

//Show Product Inquiry
$('#InquiryButton').click(function(e){
  e.preventDefault();
  $('#contactFormWrapper #InquiryVariants').empty();
  $('#InquiryFormVariants').val('');
  $('#quickview-wrapper, #ProductInquiryModal').addClass('active');
  var inquiryVariants = [];
  $('#form-actions .bold_option_element select, #form-actions .single-option-selector').each(function(){
    if($(this).val() != null){
      inquiryVariants.push($(this).val());
    }else{
      inquiryVariants.push('');
    }
  });
  //Create List of Variants selected and set the value for the input
  for(var i = 0; i<inquiryVariants.length; i++){
    if(inquiryVariants[i]){
      $('#contactFormWrapper #InquiryVariants').append('<li>-'+inquiryVariants[i]+'</li>');
      if(i==0){
        var currentValue = inquiryVariants[i];
        $('#InquiryFormVariants').val(currentValue);
      }else{
        var currentValue = $('#InquiryFormVariants').val() + ', ' + inquiryVariants[i];
        $('#InquiryFormVariants').val(currentValue);
      }
    }
  }
  //If No Variants were selected
  if($('#InquiryFormVariants').val()==''){
    $('#InquiryFormVariants').val('No Variants Selected');
  }
});
//Show Customize Inquiry
$('#CustomizeInquiryButton').click(function(e){
  e.preventDefault();
  $('#quickview-wrapper, #ProductCustomizeModal').addClass('active');
});



//Set Newsletter Cookie
$('.ctct-custom-form button[type="submit"]').click(function(){
  function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
    return pattern.test(emailAddress);
  };

  var email = $(".ctct-custom-form input[name='email']").val();  
  if (email !== "") {  // If something was entered
    if (!isValidEmailAddress(email)) {
    }else{
      Cookies.set('newsletter-subscribed', true);
    }
  } 
});

//Close Product Inquiry
$('#quickview-wrapper, #ProductInquiryModal .close').click(function(e){
  e.preventDefault();
  $('#quickview-wrapper, #ProductInquiryModal, #successForm').removeClass('active');
});

//Close Customize Inquiry
$('#quickview-wrapper, #ProductCustomizeModal .close').click(function(e){
  e.preventDefault();
  $('#quickview-wrapper, #ProductCustomizeModal, #successForm').removeClass('active');
});

//Keep search dropdown open when being used
$('.dropdown-search-bar .search-bar form.search input[type="text"]').focusin(function(){
 $('#search').addClass('active');
});

$('.dropdown-search-bar .search-bar form.search input[type="text"]').focusout(function(){
 $('#search').removeClass('active');
});



$('#CartLink').delay(1000).show();